<template>
  <div>
    <Form :model="projectItem" :label-width="120">
      <FormItem label="项目名称：" prop="projectName">
        {{ projectItem.projectName }}
      </FormItem>
      <FormItem label="使用资源：" prop="projectName">
        <template>
          <Tag
            color="primary"
            v-for="(item, index) in projectItem.projectResource"
            :key="index"
          >
            {{ item.resource.companyName }}
          </Tag>
        </template>
      </FormItem>
      <FormItem label="开始时间：" prop="startTime">
        {{ projectItem.startTime | formattime }}
      </FormItem>
      <FormItem label="结束时间：" prop="endTime">
        {{ projectItem.endTime | formattime }}
      </FormItem>
      <FormItem label="价格：" prop="price">
        {{ projectItem.price }}
      </FormItem>
      <FormItem label="承包量：" prop="amount">
        {{ projectItem.amount }}
      </FormItem>
      <FormItem label="进度：" prop="schedule">
        {{ projectItem.schedule }}
      </FormItem>
      <FormItem label="质量表现：" prop="performance">
        {{ projectItem.performance }}
      </FormItem>
    </Form>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        projectItem: {},
      };
    },
    filters: {
      formattime: function(value) {
        let d = new Date(value);
        return d.toLocaleDateString();
      },
    },
    methods: {
      setData(data) {
        this.projectItem = data;
      },
    },
  };
</script>
